(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halue-compare-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__halueCompareButtonInit) return;
    window.__halueCompareButtonInit = true;

    var STORAGE_KEY = 'halue-compare-products';
    var META_KEY = 'halue-compare-products-meta';

    function getHandles() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    function setHandles(handles) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    }

    function getMeta() {
      try {
        return JSON.parse(sessionStorage.getItem(META_KEY)) || {};
      } catch (e) {
        return {};
      }
    }

    function setMeta(meta) {
      sessionStorage.setItem(META_KEY, JSON.stringify(meta));
    }

    function syncAll() {
      var handles = getHandles();
      var toggles = document.querySelectorAll('.halue-compare-toggle[data-compare-handle]');
      for (var i = 0; i < toggles.length; i++) {
        var el = toggles[i];
        var handle = el.getAttribute('data-compare-handle');
        var active = handles.indexOf(handle) !== -1;
        el.classList.toggle('halue-compare-toggle--active', active);
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.halue-compare-toggle[data-compare-handle]');
      if (!toggle) return;

      e.preventDefault();
      var handle = toggle.getAttribute('data-compare-handle');
      var max = parseInt(toggle.getAttribute('data-max-products')) || 4;
      var handles = getHandles();
      var meta = getMeta();
      var index = handles.indexOf(handle);

      if (index !== -1) {
        handles.splice(index, 1);
        delete meta[handle];
      } else {
        if (handles.length >= max) return;
        handles.push(handle);
        meta[handle] = {
          image: toggle.getAttribute('data-product-image') || '',
          title: toggle.getAttribute('data-product-title') || '',
        };
      }

      setHandles(handles);
      setMeta(meta);
      syncAll();
      window.dispatchEvent(new CustomEvent('halue-compare:updated'));
    });

    syncAll();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    }
    window.addEventListener('pageshow', syncAll);
    window.addEventListener('halue-compare:updated', syncAll);

    new MutationObserver(function () {
      syncAll();
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halue-wishlist-button-assets"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__halueWishlistInit) return;
    window.__halueWishlistInit = true;

    var STORAGE_KEY = 'halue-wishlist-products';

    function getHandles() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    function setHandles(handles) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    }

    function syncAll() {
      var handles = getHandles();
      var btns = document.querySelectorAll('.halue-wishlist-btn[data-wishlist-handle]');
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        var handle = btn.getAttribute('data-wishlist-handle');
        var active = handles.indexOf(handle) !== -1;
        btn.classList.toggle('halue-wishlist-btn--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.halue-wishlist-btn[data-wishlist-handle]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute('data-wishlist-handle');
      var handles = getHandles();
      var index = handles.indexOf(handle);

      if (index !== -1) {
        handles.splice(index, 1);
      } else {
        handles.push(handle);
      }

      setHandles(handles);
      syncAll();
      window.dispatchEvent(new CustomEvent('halue-wishlist:updated'));
    });

    syncAll();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    }
    window.addEventListener('pageshow', syncAll);
    window.addEventListener('halue-wishlist:updated', syncAll);

    new MutationObserver(function () {
      syncAll();
    }).observe(document.body, { childList: true, subtree: true });

    window.HalueWishlist = { getHandles: getHandles };
  })();
  } catch(e) { console.error(e); }
})();

})();
